/**
 * Каталог Local SOPs / WIs / Forms (AS-2000).
 * Источник для RSD (FORM-0134486) и зеркало сида досье:
 * ``docparser-backend/finder/local_sops.py`` → ltms://Local SOPs/{SOPs|WIs|Forms}.
 * Поля: name, link (Veeva), code.
 */

export const RSD_FORM_CODE = 'FORM-0134486'

export const SOPS_SECTIONS = [
  {
    id: 'sops',
    titleKey: 'sections.sops',
    tone: 'sops',
    items: [
      {
        name: 'Процесс подготовки, подачи, отслеживания и получения документов регистрационного досье',
        code: 'SOP-0122528',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/2201285/2/0',
      },
      {
        name: 'Управление процессом внесения изменений в макеты упаковки лекарственных средств и переходом на лекарственные средства в новой упаковке',
        code: 'SOP-0122495',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/2195131/3/0',
      },
      {
        name: 'Управление процессом подготовки к регистрации и выводу на рынок новых лекарственных препаратов на территории Российской Федерации',
        code: 'SOP-0124891',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/3518153/2/0',
      },
    ],
  },
  {
    id: 'wis',
    titleKey: 'sections.wis',
    tone: 'wis',
    items: [
      {
        name: 'Создание и согласование локальной информации по препарату в отделе регистрации препаратов ООО "АстраЗенека Фармасьютикалз"',
        code: 'WI-0022242',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/2864072/1/0',
      },
      {
        name: 'Архивирование документов отдела регистрации препаратов ООО "АстраЗенека Фармасьютикалз"',
        code: 'WI-0022203',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/2859981/1/0',
      },
      {
        name: 'Порядок подготовки досье для регистрации, перерегистрации и внесения изменений на Фронтьерных рынках',
        code: 'WI-0021249',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/2676336/1/0',
      },
    ],
  },
  {
    id: 'forms',
    titleKey: 'sections.forms',
    tone: 'forms',
    items: [
      {
        name: 'Шаблон формы по разработке регуляторной стратегии лекарственного препарата',
        code: RSD_FORM_CODE,
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/3891212/1/0',
        rsdTemplate: true,
      },
      {
        name: 'Шаблон формы согласования подачи регистрационных документов',
        code: 'FORM-0130550',
        link: 'https://astrazeneca-eqv.veevavault.com/ui/#doc_info/3530394/1/0',
      },
    ],
  },
]

export const VEEVA_QUALITY_LOGO =
  'https://static-assets.veevavault.com/family/quality/dist/images/banner-logo.ef5b7987..svg'

/** Номер Forms для шапки/футера карточки RSD. */
export function getRsdFormNumber() {
  for (const section of SOPS_SECTIONS) {
    const hit = section.items.find(item => item.rsdTemplate || item.code === RSD_FORM_CODE)
    if (hit) {
      return hit.code
    }
  }
  return RSD_FORM_CODE
}
